import { SURCHARGE_STATUSES, ERRORS } from 'src/components/pages/SurchargePage/constants';

import { getPayStatus } from '.';
import * as T from '../../types';
import { PayPollingResult } from '../../types';

const timeout = 1000;

const tryAgainInTimeout = (surchargeId: string): Promise<any> => {
  return new Promise((resolve) =>
    // eslint-disable-next-line no-promise-executor-return, @typescript-eslint/no-use-before-define
    setTimeout(() => resolve(createPayPolling(surchargeId)), timeout)
  );
};

const createPayPolling = async (surchargeId: string): Promise<PayPollingResult | never> => {
  try {
    const { body } = await getPayStatus(surchargeId);

    if (!body) {
      return tryAgainInTimeout(surchargeId);
    }

    const { result, error } = body;

    if (error) {
      return Promise.reject(ERRORS.NETWORK);
    }

    const { status } = result;

    if ([SURCHARGE_STATUSES.FAIL_BLOCK, SURCHARGE_STATUSES.FAIL].includes(status)) {
      return Promise.reject(ERRORS.FAIL_ON_PAY);
    }

    if ([SURCHARGE_STATUSES.WAITING, SURCHARGE_STATUSES.BLOCK].includes(status)) {
      return tryAgainInTimeout(surchargeId);
    }

    if (status === SURCHARGE_STATUSES.BRIDGER) {
      const { postParams } = result;

      return {
        postParams,
        isBridgerPay: true,
      };
    }

    return {
      status,
    };
  } catch (e) {
    return Promise.reject(ERRORS.NETWORK);
  }
};

export default (surchargeId: string) => ({
  promise: () => createPayPolling(surchargeId),
  types: [T.PAY_POLLING, T.PAY_POLLING_SUCCESS, T.PAY_POLLING_FAIL],
});
